export default __webpack_public_path__ + "static/media/IRANYekanXFaNum-Regular.5cd696d7.woff2";